import { schema } from 'normalizr'
import moment from 'moment'

function calcSignalIntensity(val) {
  const { online, signalIntensity } = val
  if (!online) return -1
  switch (signalIntensity) {
    case 1:
      return 5
    case 2:
      return 4
    case 3:
      return 3
    case 4:
      return 2
    case 5:
      return 1
    default:
      return 0
  }
}

// 项目
export const schemaProject = new schema.Entity(
  'projects',
  {},
  {
    idAttribute(val) {
      return val.id.toString()
    },

    processStrategy(val, parent, key) {
      return {
        id: val.id.toString(),
        name: val.name,
        location: val.location,
        remark: val.remark,
        roleName: val.roleName,
        updateTime: val.createdAt || val.updatedAt,
        createdBy: val.createdBy,
        follow: val.follow,
        tag: val.tag,
        adCode: val.adCode,
        ownerName: val.ownerName,
        equipmentName: val.equipmentName,
        projectProductType: val.projectProductType,
        projectPreference: val.projectPreference,
        autoLocation: val.autoLocation,
        positionType: val.positionType,
        projectMediaList: val.projectMediaList || []
      }
    }
  }
)

// 策略
export const formatStrategy = (val) => {
  if (!val || !val.id) return {}
  const res = {
    id: val.id.toString(),
    name: val.name,
    deviceType: val.deviceType,
    periods: val.strategyTimes,
    offtime: val.offtime,
    weatherDays: val.weatherDays,
    weatherFactor: val.weatherFactor,
    isLowerLedControl: val.lowerLedControl,
    isLightControl: val.lightControl,
    isTrafficControl: val.trafficControl,
    weatherControl: val.weatherControl,
    errorTime: val.errorTime || 0,
    remark: val.remark,
    project: val.projectId ? val.projectId.toString() : '',
    createTime: val.createdAt,
    updateTime: val.updatedAt,
    backTime: Date.now(),
    strategyTimes: val.strategyTimes,
    strategySendAt: val.strategySendAt,
    isAnnualControl: val.annualControl,
    lowerLed: val.lowerLed,
    templateType: val.templateType,
    energySaving: val.energySaving,
    dayBreakStrategyTime: val.dayBreakStrategyTime
  }
  return res
}

export const schemaStrategy = new schema.Entity(
  'strategies',
  {},
  {
    idAttribute(val) {
      return val.id.toString()
    },

    processStrategy(val, parent, key) {
      const res = formatStrategy(val)
      return res
    }
  }
)

// 分组
export const schemaGroup = new schema.Entity(
  'groups',
  {
    project: schemaProject
  },
  {
    idAttribute(val) {
      return val.id.toString()
    },

    processStrategy(val, parent, key) {
      const res = {
        id: val.id.toString(),
        name: val.name,
        remark: val.remark,
        createTime: val.createdAt
      }
      if (val.project) {
        res.project = val.project
      } else {
        res.project = val.projectId.toString()
      }
      return res
    }
  }
)

// 用户
export const schemaUser = new schema.Entity(
  'users',
  {},
  {
    idAttribute(val) {
      return val.id.toString()
    },

    processStrategy(val, parent, key) {
      const res = {
        id: val.id.toString(),
        username: val.username,
        roleName: val.roleName,
        project: val.domainId.toString()
      }
      return res
    }
  }
)

// 配置
export const formatConfig = (data) => {
  const res = {
    project: data.projectId.toString(),
    brightness: data.projectDefaultBrightness
  }
  return res
}

export const schemaConfig = new schema.Entity(
  'configs',
  {},
  {
    idAttribute(val) {
      return val.projectId.toString()
    },

    processStrategy(val, parent, key) {
      const res = formatConfig(val)
      return res
    }
  }
)

// 告警
export const schemaWarning = new schema.Entity(
  'warnings',
  {},
  {
    idAttribute(val) {
      return val.id.toString()
    },

    processStrategy(val, parent, key) {
      const res = {
        id: val.id.toString(),
        deviceId: val.targetId.toString(),
        deviceName: val.moteName,
        project: val.projectId.toString(),
        type: val.alertType,
        level: val.alertLevel,
        state: val.alertStatus,
        text: val.dataStr,
        updateTime: val.updatedAt || val.createdAt
      }
      return res
    }
  }
)

// 设备
export const schemaDevice = new schema.Entity(
  'devices',
  {
    project: schemaProject,
    strategy: schemaStrategy
  },
  {
    idAttribute(val) {
      return val.id.toString()
    },
    processStrategy(val, parent, key) {
      const res = {
        id: val.id.toString(),
        name: val.name,
        lng: val.lng,
        lat: val.lat,
        snHexadecimal: val.sn.toString(16),
        pnHex: val.pn.toString(16),
        isGateway: val.asGateway,
        isOnline: Boolean(val.online),
        isOpen: Boolean(val.switchState),
        isWarning: Boolean(val.alertState),
        isDisable: Boolean(val.disabled),
        paramSettingMode: val.paramSettingMode,
        ledRatedCurrent: val.ledRatedCurrent,
        batteryType: val.batteryType,
        batteryVoltage: val.batteryVoltage,
        batteryOverVoltage: val.batteryOverVoltage,
        batteryOverToBackVoltage: val.batteryOverToBackVoltage,
        batteryLowVoltage: val.batteryLowVoltage,
        batteryLowToBackVoltage: val.batteryLowToBackVoltage,
        dayThreshold: val.dayThreshold,
        nightThreshold: val.nightThreshold,
        updateTime: val.updatedAt,
        createdAt: val.createdAt,
        signalIntensity: calcSignalIntensity(val),
        simNo: val.simNo,
        splicesTianYing: val.splicesTianYing,
        brightness: (val.online && val.switchState) ? val.brightness : 0,
        isSettedStrategy: val.strategySettingState,
        isSettedParam: val.paramSettingState,
        spareBatteryVoltage: val.spareBatteryVoltage,
        spareBatteryCurrent: val.spareBatteryCurrent,
        pvSolarVolt: val.pvSolarVolt,
        pvSolarCurrent: val.pvSolarCurrent,
        solarVoltage: (val.solarVoltage / 1000).toFixed(2) * 1,
        solarCurrent: (val.solarCurrent / 1000).toFixed(2) * 1,
        batteryVolt: (val.batteryVolt / 1000).toFixed(2) * 1,
        batteryCurr: 0 - (val.batteryCurr / 1000).toFixed(2),
        ledVolt: (val.ledVolt / 1000).toFixed(2) * 1,
        ledCurr: (val.ledCurr / 1000).toFixed(2) * 1,
        cellCharge: (val.cellCharge * 1).toFixed(2) * 1,
        cellDischarge: (val.cellDischarge * 1).toFixed(2) * 1,
        cellResidue: (val.cellResidue * 1).toFixed(2) * 1,
        temperatures: val.temperatures * 1,
        batteryCapacity: val.batteryCapacity,
        switchMode: val.switchMode,
        groupName: val.groupName,
        paramSendAt: val.paramSendAt,
        cellLevel: val.cellLevel,
        // 多了钠离子电池，算法变更
        // cellResidue: (function() {
        //   let value = 100
        //   if (val.batteryVolt <= val.batteryLowVoltage) value = 0
        //   if (val.batteryVolt >= val.batteryOverVoltage) value = 100
        //   let valueSrc = (val.batteryVolt - val.batteryLowVoltage) / (val.batteryOverVoltage - val.batteryLowVoltage) * 100
        //   value = Math.floor(valueSrc)
        //   return value
        // })(),
        // cellLevel: (function() {
        //   let level = 4
        //   if (this.cellResidue < 5) level = 0
        //   if (this.cellResidue >= 5 && this.cellResidue < 25) level = 1
        //   if (this.cellResidue >= 25 && this.cellResidue < 50) level = 2
        //   if (this.cellResidue >= 50 && this.cellResidue < 75) level = 3
        //   if (this.cellResidue >= 75 && this.cellResidue <= 100) level = 4
        //   return level
        // })(),
        chargeState: val.chargeState,
        extendOption: val.gatewayExtendOption,
        trafficWorkMode: val.trafficWorkMode,
        switchingPowerSupplyVoltage: val.switchingPowerSupplyVoltage,
        environmentTemperature: val.environmentTemperature,
        productType: val.productType,
        webcamAddress: val.webcamAddress,
        strongChargeVoltage: val.strongChargeVoltage,
        evenChargeVoltage: val.evenChargeVoltage,
        floatChargeVoltage: val.floatChargeVoltage,
        boostChargeVoltage: val.boostChargeVoltage,
        communicationMode: val.communicationMode,
        communicationState: val.communicationState,
        dcVoltage: val.dcVoltage,
        templateType: val.templateType,
        outsideTemperature: val.outsideTemperature,
        lightControlDelayTime: val.lightControlDelayTime,
        sleepState: val.sleepState,
        fourthGenerationFlowSwitchState: val.fourthGenerationFlowSwitchState,
        volVoltage: (val.volVoltageSwitch / 1000).toFixed(2),
        volCurr: (val.volCurrSwitch / 1000).toFixed(2),
        solarVolCurr: (val.volVoltageSwitch * val.volCurrSwitch).toFixed(2),
        signalValue: val.signalValue

      }
      // 关联项目
      if (val.project) {
        res.project = val.project
      } else {
        res.project = val.projectId.toString()
      }
      // 关联分组
      if (val.group) {
        res.group = val.group
      } else {
        res.group = val.groupId.toString()
      }
      return res
    }
  }
)

// 设备概要
export const schemaDeviceSimple = new schema.Entity(
  'devices_simple',
  {},
  {
    idAttribute(val) {
      return val.id.toString()
    },
    processStrategy(val, parent, key) {
      const res = {
        id: val.id.toString(),
        project: val.projectId.toString(),
        name: val.name,
        lng: val.lng,
        lat: val.lat,
        projectName: val.projectName
      }
      return res
    }
  }
)

// 单灯单日统计数据
export const schemaStatisticStatus = new schema.Entity(
  'statistic_status',
  {},
  {
    idAttribute(val) {
      return moment(val.createdAt).format('HH:mm:ss')
    },

    processStrategy(val, parent, key) {
      // time
      const time = moment(val.createdAt).format('HH:mm:ss')
      // solar
      const solarVoltage = val.solarVoltage / 1000
      const solarCurrent = val.solarCurrent / 1000
      const solarPower = solarVoltage * solarCurrent
      // volCurr
      const volVoltage = val.volVoltageSwitch / 1000
      const volCurr = val.volCurrSwitch / 1000
      const solarVolCurr = volVoltage * volCurr
      // battery
      const batteryVolt = val.batteryVolt / 1000
      const batteryCurr = 0 - val.batteryCurr / 1000
      const batteryPower1 = batteryVolt * batteryCurr
      // led
      const ledVoltage = val.ledVolt / 1000
      const ledCurrent = val.ledCurr / 1000
      const ledPower = ledVoltage * ledCurrent
      const brightness = (val.online && val.switchState) ? val.brightness : 0
      const powerSupply = val.powerSupplyMode
      const calCurr = solarCurrent > 0 ? (solarCurrent * solarVoltage * 0.8 / batteryVolt) : (ledCurrent * ledVoltage * 0.95 / batteryVolt) > 0 ? (ledCurrent * ledVoltage * 0.95 / batteryVolt) : 0
      const batteryPower = batteryVolt * calCurr
      // energy
      const cellCharge = val.cellCharge
      const cellDischarge = val.cellDischarge
      const cellResidue = val.cellResidue
      // 其他
      const temperatures = val.temperatures
      const signalValue = val.signalValue
      const communicationMode = val.communicationMode
      const dcVoltage = val.dcVoltage
      const outsideTemperature = val.outsideTemperature
      const dimmerMode = val.dimmerMode / 100
      const switchMode = val.switchMode

      const res = {
        time,
        solarVoltage,
        solarCurrent,
        solarPower,
        batteryVolt,
        batteryCurr,
        batteryPower,
        batteryPower1,
        ledVoltage,
        ledCurrent,
        ledPower,
        brightness,
        cellCharge,
        cellDischarge,
        cellResidue,
        temperatures,
        signalValue,
        powerSupply,
        communicationMode,
        dcVoltage,
        calCurr,
        outsideTemperature,
        dimmerMode,
        volVoltage,
        volCurr,
        solarVolCurr,
        switchMode
      }
      return res
    }
  }
)

// 统计充电量和放电量
export const schemaStatisticCharge = new schema.Entity(
  'statistic_charge',
  {},
  {
    idAttribute(val) {
      return val.date
    },

    processStrategy(val, parent, key) {
      const res = {
        date: val.date,
        cellCharge: val.cellCharge,
        cellDisCharge: val.cellDischarge,
        temperaturesMax: val.temperaturesMax || '',
        temperaturesMin: val.temperaturesMin || ''
      }
      return res
    }
  }
)

// 统计亮灯时长
export const schemaStatisticLighting = new schema.Entity(
  'statistic_lighting',
  {},
  {
    idAttribute(val) {
      return val.date
    },

    processStrategy(val, parent, key) {
      const res = {
        date: val.date,
        lightTime: val.lightTime ? Number(val.lightTime.toFixed(2)) : null
      }
      return res
    }
  }
)

// 操作日志
export const schemaLog = new schema.Entity(
  'logs',
  {},
  {
    idAttribute(val) {
      return val.id.toString()
    },

    processStrategy(val, parent, key) {
      const res = {
        id: val.id.toString(),
        type: val.opType,
        content: val.content,
        username: val.username,
        createTime: val.createdAt,
        operator: val.operator
      }
      return res
    }
  }
)

// 格式化分页设备数据
export const formatDevicePagi = (val) => {
  val.records.forEach(item => {
    item.name = item.name
    item.projectId = item.projectId
    item.groupId = item.groupId
    item.batteryType = item.batteryType
    item.batteryVoltage = item.batteryVoltage
    item.username = item.username
    item.sn = item.sn
    item.pn = item.pn
    item.snHexadecimal = item.snHexadecimal
    item.pnHexadecimal = item.pnHexadecimal
    item.lng = item.lng
    item.lat = item.lat
    item.asGateway = item.asGateway
    item.gatewayOption = item.gatewayOption
    item.solarVoltage = (item.solarVoltage / 1000).toFixed(2) * 1
    item.solarCurrent = (item.solarCurrent / 1000).toFixed(2) * 1
    item.batteryVolt = (item.batteryVolt / 1000).toFixed(2) * 1
    item.batteryCurr = 0 - (item.batteryCurr / 1000).toFixed(2)
    item.ledVolt = (item.ledVolt / 1000).toFixed(2) * 1
    item.ledCurr = (item.ledCurr / 1000).toFixed(2) * 1
    item.cellCharge = (item.cellCharge * 1).toFixed(2) * 1
    item.cellDischarge = (item.cellDischarge * 1).toFixed(2) * 1
    // 多了钠离子电池，算法变更
    // item.cellResidue = (item.cellResidue * 1).toFixed(2) * 1
    // item.cellLevel = item.cellLevel
    item.cellResidue = (function() {
      let value = 100
      if (item.batteryVolt <= item.batteryLowVoltage) {
        value = 0
      } else if (item.batteryVolt >= item.batteryOverVoltage) {
        value = 100
      } else {
        let valueSrc = (item.batteryVolt - item.batteryLowVoltage) / (item.batteryOverVoltage - item.batteryLowVoltage) * 100
        value = Math.floor(valueSrc)
        console.log('value', value)
      }
      return value
    })()
    item.cellLevel = (function() {
      let level = 4
      if (item.cellResidue < 5) level = 0
      if (item.cellResidue >= 5 && item.cellResidue < 25) level = 1
      if (item.cellResidue >= 25 && item.cellResidue < 50) level = 2
      if (item.cellResidue >= 50 && item.cellResidue < 75) level = 3
      if (item.cellResidue >= 75 && item.cellResidue <= 100) level = 4
      console.log('level', level)
      return level
    })()
    item.temperatures = item.temperatures
    item.switchState = item.switchState
    item.switchMode = item.switchMode
    item.brightness = (item.online && item.switchState) ? item.brightness : 0
    item.chargeState = item.chargeState
    item.isOnline = Boolean(item.online)
    item.isOpen = Boolean(item.switchState)
    item.isWarning = Boolean(item.alertState)
    item.isDisable = Boolean(item.disabled)
    item.id = item.id
    item.createdAt = item.createdAt
    item.updateTime = item.updatedAt
    item.deletedAt = item.deletedAt
    item.createdBy = item.createdBy
    item.updatedBy = item.updatedBy
    item.deletedBy = item.deletedBy
    item.signalValue = item.signalValue
    item.batteryOverVoltage = item.batteryOverVoltage
    item.batteryOverToBackVoltage = item.batteryOverToBackVoltage
    item.batteryLowVoltage = item.batteryLowVoltage
    item.batteryLowToBackVoltage = item.batteryLowToBackVoltage
    item.ledRatedCurrent = item.ledRatedCurrent
    item.dayThreshold = item.dayThreshold
    item.nightThreshold = item.nightThreshold
    item.signalIntensity = calcSignalIntensity(item)
    item.paramSettingMode = item.paramSettingMode
    item.batteryCapacity = item.batteryCapacity
    item.strategySettingState = item.strategySettingState
    item.paramSettingState = item.paramSettingState
    item.groupName = item.groupName
    item.onlineTime = item.onlineTime
    item.openTime = item.openTime
    item.traffic = item.traffic
    item.paramSendAt = item.paramSendAt
    item.lowerLedParam = item.lowerLedParam
    item.zeroChargeType = item.zeroChargeType
    item.firmwareName = item.firmwareName
    item.powerSupplyMode = item.powerSupplyMode
    item.switchingPowerSupplyVoltage = item.switchingPowerSupplyVoltage
    item.trafficWorkMode = item.trafficWorkMode
    item.productType = item.productType
    item.webcamAddress = item.webcamAddress
    item.strongChargeVoltage = item.strongChargeVoltage
    item.evenChargeVoltage = item.evenChargeVoltage
    item.floatChargeVoltage = item.floatChargeVoltage
    item.dcVoltage = item.dcVoltage
    item.environmentTemperature = item.environmentTemperature
    item.productLine = item.productLine
    item.communicationMode = item.communicationMode
    item.insideTemperature = item.insideTemperature
    item.outsideTemperature = item.outsideTemperature
    item.deviceCurrentHour = item.deviceCurrentHour
    item.deviceCurrentMinute = item.deviceCurrentMinute
    item.deviceCurrentSecond = item.deviceCurrentSecond
    item.boostChargeVoltage = item.boostChargeVoltage
    item.communicationState = item.communicationStatecommunicationState
    item.sleepState = item.sleepState
    item.h5WebcamAddress = item.h5WebcamAddress
    item.volVoltage = (item.volVoltageSwitch / 1000).toFixed(2) * 1
    item.volCurr = (item.volCurrSwitch / 1000).toFixed(2) * 1
    item.solarVolCurr = (item.volVoltage * item.volCurr).toFixed(2) * 1
    item.splicesTianYing = item.splicesTianYing
    item.moteStatus = item.moteStatus
    item.endPayAt = item.endPayAt
  })
  const res = {
    recordCount: val.recordCount,
    pageCount: val.pageCount,
    pageNo: val.pageNo,
    pageSize: val.pageSize,
    records: val.records
  }
  return res
}
